import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import useRouter from 'utils/useRouter';
import { Page, Header } from 'components';
import ElementDataTable from './components/ElementDataTable.js';
// import AddEditUsersDialog from './components/AddEditUserDialog/AddEditUserDialog.js'
import { GetActivities, GetElementTaskCompletion } from '../../actions/ElementViewActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
}));

const ElementView = () => {
	const classes = useStyles();
	const { history } = useRouter();
	const dispatch = useDispatch();
	const activities = useSelector(state => state.elementViewReducer.activities);
	const elementTaskCompletion = useSelector(state => state.elementViewReducer.elementTaskCompletion);

	const _getData = useCallback(() => {
		dispatch(GetActivities());
		dispatch(GetElementTaskCompletion());
	}, []);

	useEffect(() => {
		_getData();
	}, [_getData]);

	const _openActivityDetails = (id) => {
		history.push(`/tracker/activitydetails/${id}`);
	};

	return (
		<Page className={classes.root} title="Tracker">
			<Header module="Tracker" view="Element Level" />
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={12} xs={12}>
					<ElementDataTable
						className={classes.results}
						data={elementTaskCompletion && elementTaskCompletion.map(item => {
							let object = { element: item.element };
							item.activities.map(element => {
								object = { ...object, [`activity_${element.activityId}`]: element.completion };
								return true;
							});
							return object;
						})}
						activities={activities}
						openActivityDetails={_openActivityDetails}
					/>
				</Grid>
			</Grid>
			{/* {openAddEditUserDialog && <AddEditUsersDialog
				onClose={_addEditUserClose}
				open={openAddEditUserDialog}
				user={user}
			/>} */}
		</Page>

	);
};

export default ElementView;
